const menuSi = {
    "add_to_cart": "Dodaj v košarico",
    "add_to_order": "Dodaj k naročilu",
    "already_in_cart": "Že v vaši košarici",
    "update_order_item": "Posodobi naročilo",
    "delete_order_item": "Odstrani element",
    "available_categories": "Kategorije menija",
    "search_menu_placeholder": "Iskanje v meniju",
    "guides": {
        "scan_qr": "S telefonom skenirajte QR kodo na mizi",
        "order": "Naročite izbrane artikle s telefona",
        "pay": "Plačajte ločeno ali vse naenkrat s telefona",
        "accept": "Nadaljuj"
    },
    "index_image": "Indeksna slika",
    "menu_saved": "Meni shranjen",
    "new_category": "Nova kategorija",
    "menu_editor": "Meni urejevalnika",
    "new_item": "Nov element",
    "menu": "Meni",
    "allergens": "Alergeni",
    "generate_qr": "Ustvari QR kodo",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "Raki",
        "eggs": "Jajca",
        "fish": "Ribe",
        "peanuts": "Arašidi",
        "soybeans": "Soja",
        "milk": "Mleko",
        "nuts": "Oreški",
        "celery": "Zelena",
        "mustard": "Gorčica",
        "sesame": "Sezam",
        "sulphur_dioxide": "Žveplov dioksid",
        "lupin": "Lupin",
        "molluscs": "Mehkužci",
        "vegan": "Vegansko"
    },
    "add_allergen": "Dodaj alergen",
    "auto_translate": "Prevod menija",
    "no_category_name": "V trenutnem jeziku ni določeno ime kategorije",
    "no_item_name": "V trenutnem jeziku ni določeno ime elementa",
    "category_and_items_language": "Jezik kategorij in elementov",
    "auto_translate_title": "Samodejno prevajanje menijev je mogoče uporabiti samo za kategorije in elemente, ki so že shranjeni. Priporočljivo je, da vnesete začetni jezik.",
    "auto_translate_description": "Ta funkcija uporablja Google Prevajalnik. Prevodi niso vedno točni, zato jih je vredno preveriti.",
    "translate_from": "Prevedi iz",
    "translate_to": "V te jezike",
    "auto_translate_error_invalid_languages": "Za prevod so izbrani neveljavni jeziki",
    "auto_translate_success": "Meni je bil uspešno preveden",
    "auto_translate_error_permission": "Nimate dovoljenja za prevajanje menija",
    "auto_translate_error_generic": "Med prevajanjem je prišlo do neznane napake",
    "auto_translate_feature_not_available": "Samodejno prevajanje menijev je na voljo samo s PRO naročnino.",
    "change_subscription_plan": "Spremeni naročniški paket",
    "menu_headers": "Glave in noge menijev",
    "menu_header_editor_title": "Glave in noge menijev so besedila, ki se prikažejo na vrhu in dnu vašega spletnega menija in jih lahko poljubno določite.",
    "menu_header_feature_not_available": "Urejanje glave in noge menija je na voljo samo s PRO naročnino.",
    "menu_header": "Glava menija",
    "menu_header_placeholder": "Napišite kratko pozdravno sporočilo ali označite trenutno ponudbo",
    "menu_footer": "Noga menija",
    "menu_footer_placeholder": "Vnesete lahko podatke o stroških storitev, alergenih ali druge pomembne informacije",
    "menu_header_save_success": "Glava in noga menija sta bila uspešno shranjena",
    "menu_header_save_error": "Pri shranjevanju glave in noge menija je prišlo do napake.",
    "menu_header_permission_error": "Nimate dovoljenja za urejanje glave in noge menija.",
    "menu_header_generic_error": "Pri nalaganju glave in noge menija je prišlo do neznane napake.",
    "menu_import": "Uvoz menija",
    "import_success": "Zadnji uvoz je bil uspešno zaključen",
    "import_failed": "Zadnji uvoz ni uspel zaradi izvoza na strani strežnika.",
    "attached_document": "Priloženi dokument",
    "allowed_file_types": "Dovoljene vrste datotek: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Jezik dokumenta",
    "import_options_pro_helpertext": "Možnosti »Deaktiviraj« in »Dodaj« sta na voljo samo s PRO naročnino.",
    "import_option_helpertexts": {
        "replace": "Trenutne kategorije in elementi menija bodo izbrisani in nadomeščeni z novo ustvarjenim menijem.",
        "deactivate": "Trenutne kategorije in elementi menija bodo deaktivirani, dodan pa bo novo ustvarjen meni.",
        "add": "Trenutni meni bo ostal, novi elementi menija pa bodo dodani za trenutnim menijem."
    },
    "import_type": "Vrsta uvoza",
    "import_options": {
        "replace": "Zamenjaj",
        "deactivate": "Deaktiviraj",
        "add": "Dodaj"
    },
    "menu_import_tooltip": "Naložite datoteko z jedilnikom vaše restavracije ali navedite povezavo do spletnega mesta, ki vsebuje jedilnik. V obeh primerih se prepričajte, da je jedilnik v dokumentu na voljo v besedilni obliki, saj slik ne moremo obdelati. Po začetku uvoza bo naša umetna inteligenca samodejno obdelala datoteko in ustvarila nov jedilnik v izbranem jeziku. Če želite pozneje prevesti elemente v več jezikov, uporabite funkcijo »Prevajanje jedilnika«! Postopek uvoza traja 5–10 minut.",
    "menu_import_replace_warning": "Trenutno izbrana metoda uvoza bo izbrisala trenutni meni in ga nadomestila z novim menijem. Prepričajte se, da ima naložena datoteka pravilno obliko in vsebino, saj je operacija nepreklicna! Če ne želite izbrisati trenutnega menija, izberite drugo metodo uvoza.",
    "start_import": "Uvoz",
    "file_or_url_required": "Izberite datoteko ali navedite URL spletnega mesta",
    "file_and_url_error": "Navedete lahko samo datoteko ali URL, ne obojega",
    "import_site_url": "URL spletnega mesta",
    "import_in_progress": "Uvoz v teku",
    "import_duration": "To lahko traja nekaj minut",
    "listing_manager_info": {
        "summary": "Z Mozrestom lahko preprosto upravljate svoje oglase in ocene z ene same platforme. Prihranite čas, izboljšajte svoj spletni ugled in povečajte operativno učinkovitost.",
        "bullet_1": "Takoj posodobite svoje vnose na Tripadvisorju, Apple Maps, Googlu, Facebooku, Quandooju in Bingu z enim samim klikom.",
        "bullet_2": "Prejemajte obvestila v realnem času, ko se vaš delovni čas in razpoložljivost ne ujemata, s čimer preprečite razočaranje gostov in negativne ocene.",
        "bullet_3": "Hitro preverite popolnost svojega vnosa, da zagotovite, da so vse pomembne podrobnosti – kot so fotografije, jedilniki in delovni čas – točne in posodobljene.",
        "setup_button": "Nastavitev Mozresta",
        "pro_warning": "Za to funkcijo je potrebna naročnina PRO."
    },
    "listing_manager_tabs": {
        "Listing": "Seznam",
        "ListingAnalytics": "Analitika oglasov",
        "ReviewsPage": "Ocene",
        "ReviewAnalytics": "Analitika pregledov",
        "ReplyTemplates": "Predloge za odgovore",
        "Notifications": "Obvestila"
    },
    "review_manager_set_title": "Nastavitev upravitelja pregledov",
    "review_manager_set_description": "Prosimo, navedite nekaj informacij o svojem podjetju, da bomo lahko ustvarili vaše osnovne nastavitve.",
    "confirm_settings": "Potrdi nastavitve"
};

export default menuSi;
